<div class="overlay"></div>
<mat-card class="panel">
  <mat-card-header>
    <mat-card-title class="centered-title">Nuovo Evento</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="eventForm">
      <mat-button-toggle-group formControlName="isAppointment">
        <mat-button-toggle [value]="true">PsicoGenius</mat-button-toggle>
        <mat-button-toggle [value]="false">Altro</mat-button-toggle>
      </mat-button-toggle-group>

      <!-- Patient Name -->
      @if (eventForm.get("isAppointment")?.value) {
        @if (patients.length === 0) {
          <mat-error> Non sono disponibili pazienti nel sistema </mat-error>
        }
        <mat-form-field appearance="fill" color="primary">
          <mat-label>Paziente</mat-label>
          <input
            matInput
            formControlName="patientName"
            [matAutocomplete]="auto"
            (focus)="showAllPatients()"
            (input)="filterPatients()"
          />
          <mat-autocomplete #auto="matAutocomplete">
            @for (patient of filteredPatients; track patient) {
              <mat-option
                [value]="patient.first_name + ' ' + patient.last_name"
                (onSelectionChange)="selectPatient(patient)"
              >
                {{ patient.first_name }} {{ patient.last_name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }

      <!-- List of calendars -->
      @if (!eventForm.get("isAppointment")?.value) {
        <mat-form-field appearance="fill">
          <mat-label>Calendario</mat-label>
          <mat-select formControlName="calendarName">
            @for (calendar of calendars; track calendar) {
              <mat-option
                [value]="calendar.summary"
                (onSelectionChange)="selectCalendar(calendar)"
              >
                {{ calendar.summary }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <!-- Title -->
      <mat-form-field appearance="fill">
        <mat-label>Titolo</mat-label>
        <input matInput formControlName="title" />
      </mat-form-field>

      <!-- Date -->
      <mat-form-field appearance="fill">
        <mat-label>Data</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          formControlName="date"
          appDateInput
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <!-- Time -->
      <div class="time-fields">
        <mat-form-field appearance="fill">
          <mat-label>Ora inizio</mat-label>
          <input
            matInput
            formControlName="startTime"
            type="time"
            placeholder="HH:mm"
          />
          <mat-timepicker-toggle matSuffix></mat-timepicker-toggle>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Durata</mat-label>
          <input
            matInput
            formControlName="length"
            placeholder="45"
            type="number"
          />
        </mat-form-field>
      </div>
      <div class="toggle-container">
        <mat-slide-toggle formControlName="isRemote">Online</mat-slide-toggle>
        @if (!eventForm.get("isAppointment")?.value) {
          <mat-slide-toggle formControlName="isAllDay"
            >Tutto il giorno</mat-slide-toggle
          >
        }
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <button class="button-white" mat-button (click)="onCancel()">
      {{ labelService.getLabel("cancel") }}
    </button>
    <button
      class="button-white"
      mat-raised-button
      (click)="onConfirm()"
      [disabled]="!eventForm.valid || isBtnClicked"
    >
      {{ labelService.getLabel("confirm") }}
    </button>
  </mat-card-actions>
  @if (isPsicogeniusSelected && !eventForm.get("isAppointment")?.value) {
    <mat-error>
      Seleziona appuntamento Psicogenius se vuoi aggiungere un evento in questo
      calendario
    </mat-error>
  }
</mat-card>
